import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AvatarComponent } from '@fundamental-ngx/core/avatar';
import { ButtonComponent } from '@fundamental-ngx/core/button';
import {
  CardComponent,
  CardContentComponent,
  CardFooterActionItemDirective,
  CardFooterComponent,
} from '@fundamental-ngx/core/card';
import { IconComponent } from '@fundamental-ngx/core/icon';
import { TitleComponent } from '@fundamental-ngx/core/title';

@Component({
  selector: 'app-help-center-card',
  imports: [
    CardComponent,
    CardContentComponent,
    CardFooterComponent,
    CardFooterActionItemDirective,
    AvatarComponent,
    IconComponent,
    TitleComponent,
    ButtonComponent,
  ],
  templateUrl: './help-center-card.component.html',
  styleUrl: './help-center-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpCenterCardComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) subtitle!: string;
  @Input({ required: true }) glyph!: string;
  @Input({ required: true }) buttonText!: string;
  @Input({ required: true }) buttonDataTestId!: string;

  @Output()
  readonly buttonClicked: EventEmitter<string> = new EventEmitter<string>();

  emitClickedEvent() {
    this.buttonClicked.emit();
  }
}
